module.exports = __webpack_public_path__ + "@/assets/img/vector-1.8cb7f958.png";